import React, { useEffect, useState } from "react";
import { getProfileAvatar } from "../../utils/profileAvatar";

const FarmAvatar = ({
  profile,
  user,
  className = "",
  showInitialBadge = true,
}) => {
  const avatarProfile = profile || user || {};
  const avatar = getProfileAvatar(avatarProfile);
  const [renderFailed, setRenderFailed] = useState(false);
  const classes = ["profile-avatar", className].filter(Boolean).join(" ");
  const displayName =
    avatarProfile.name || avatarProfile.displayName || "Community member";

  useEffect(() => {
    setRenderFailed(false);
  }, [avatar.photo, avatar.asset]);

  useEffect(() => {
    if (
      avatar.type === "fallback" &&
      !avatar.asset &&
      process.env.NODE_ENV === "development"
    ) {
      console.warn(
        `FarmAvatar asset is missing for ${avatar.animal}. Using initials fallback.`
      );
    }
  }, [avatar.animal, avatar.asset, avatar.type]);

  if (avatar.type === "photo") {
    return (
      <img
        src={avatar.photo}
        alt={avatar.label}
        className={`${classes} profile-avatar-img`}
      />
    );
  }

  if (renderFailed || !avatar.asset) {
    return (
      <span
        className={`${classes} profile-avatar-fallback profile-avatar-neutral ${avatar.colorClassName || ""}`}
        role="img"
        aria-label={`Avatar for ${displayName}.`}
      >
        <span className="profile-avatar-safe-mark" aria-hidden="true" />
        {showInitialBadge && (
          <span className="profile-avatar-initials" aria-hidden="true">
            {avatar.initials}
          </span>
        )}
      </span>
    );
  }

  return (
    <span
      className={`${classes} profile-avatar-fallback ${avatar.colorClassName}`}
      role="img"
      aria-label={avatar.label}
      data-avatar-animal={avatar.animal}
      data-avatar-color={avatar.colorId}
    >
      <img
        src={avatar.asset}
        alt=""
        className="profile-avatar-icon"
        draggable="false"
        onError={() => {
          if (process.env.NODE_ENV === "development") {
            console.warn(
              `FarmAvatar asset failed to load for ${avatar.animal}. Using initials fallback.`
            );
          }
          setRenderFailed(true);
        }}
      />
      {showInitialBadge && (
        <span className="profile-avatar-initials" aria-hidden="true">
          {avatar.initials}
        </span>
      )}
    </span>
  );
};

export default FarmAvatar;
